const EMAIL_ADDRESS_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MIN_NAME_LENGTH = 2;

interface DeliveryIdentityRequirementInput {
    isPreview: boolean;
    sessionFirstName?: string | null;
}

interface DeliveryIdentityValidationInput {
    requiresName: boolean;
    requiresEmail: boolean;
    name: string;
    email: string;
}

export interface DeliveryIdentityRequirement {
    requiresName: boolean;
    requiresEmail: boolean;
}

export function normalizeDeliveryName(name?: string | null): string {
    return typeof name === 'string' ? name.trim() : '';
}

export function hasUsableDeliveryName(name?: string | null): boolean {
    return normalizeDeliveryName(name).length >= MIN_NAME_LENGTH;
}

export function getDeliveryIdentityRequirement({
    isPreview,
    sessionFirstName,
}: DeliveryIdentityRequirementInput): DeliveryIdentityRequirement {
    if (isPreview) {
        return {
            requiresName: true,
            requiresEmail: true,
        };
    }

    return {
        requiresName: !hasUsableDeliveryName(sessionFirstName),
        requiresEmail: false,
    };
}

export function validateDeliveryIdentity({
    requiresName,
    requiresEmail,
    name,
    email,
}: DeliveryIdentityValidationInput): Record<string, string> {
    const errors: Record<string, string> = {};
    const normalizedName = normalizeDeliveryName(name);
    const normalizedEmail = email.trim();

    if (requiresName) {
        if (!normalizedName) errors.receiverName = 'This field is required.';
        else if (normalizedName.length < MIN_NAME_LENGTH) errors.receiverName = 'Enter at least 2 characters.';
    }

    if (requiresEmail) {
        if (!normalizedEmail) errors.receiverEmail = 'This field is required.';
        else if (!EMAIL_ADDRESS_REGEX.test(normalizedEmail)) errors.receiverEmail = 'Enter a valid email.';
    }

    return errors;
}
